import React from 'react';
// import { Redirect } from 'react-router-dom';
import './insights.scss';
import Header from '../../containers/Header/header';
import Footer from '../../containers/Footer/footer';
import { auth as AuthObject } from '../../services/login'
import '../../containers/Header/header.scss';
import cookie from '../../cookieHelper/cookie';
import toastNotify from '../../utils/toastNotifier';
import getStoryInsights from '../../services/getStoryInsights';
import getStoryInsightsV2 from '../../services/getStoryInsightsV2';
import withRouter from '../../containers/withRouter';
import { Navigate } from 'react-router-dom';

const sumCounts = (a, b) => (Number(a) || 0) + (Number(b) || 0);

// yyyy-mm-dd in local time, as used by <input type="date">
const toDateInputValue = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

const getLast30DaysRange = () => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 30);
    return { startDate: toDateInputValue(start), endDate: toDateInputValue(end) };
};

const formatDisplayDate = (value) => value.split('-').reverse().join('/');



class Insights extends React.Component {
    constructor(props) {
        super(props);
        this.storyId = this.props.params.storyID;
        const defaultRange = getLast30DaysRange();
        this.state = {
            selectedPlatform: " ",
            totalData: "",
            startDate: defaultRange.startDate,
            endDate: defaultRange.endDate,
            totalReportData: "",
            reportHeading: "Last 30 days insights",
            clicked: false,
            tokencheck: true
        }
        this.data = {
            storyId: this.storyId
        }
    }

    componentDidMount() {
        // The all-time insights call is slow, so the general page opens with the last 30 days report instead.
        if (typeof this.storyId == 'undefined') {
            this.fetchReport(this.state.startDate, this.state.endDate, "Last 30 days insights");
        } else {
            this.validateData(this.data);
        }
    }
    setCompanyID = (e) => {
        e.preventDefault();
        this.setState({
            selectedPlatform: e.target.value
        })
    }

    setStartDate = (e) => {
        this.setState({
            startDate: e.target.value
        })
    }
    setEndDate = (e) => {
        this.setState({
            endDate: e.target.value
        })
    }

    handleClick = async (e) => {
        e.preventDefault();
        const { startDate, endDate } = this.state;
        if (startDate != "" && endDate != "") {
            this.fetchReport(startDate, endDate, `Insights from ${formatDisplayDate(startDate)} to ${formatDisplayDate(endDate)}`);
        }
        else{
            toastNotify(3, "please select start-end dates");
        }
    }

    fetchReport = async (startDate, endDate, reportHeading) => {
        const requestId = this.reportRequestId = (this.reportRequestId || 0) + 1;
        this.setState({
            clicked: true,
            totalReportData: ""
        })
        const data = {
            startDate,
            endDate
        }
        let result = await getStoryInsightsV2(data, "story");
        // Ignore a response that was overtaken by a newer date range.
        if (requestId !== this.reportRequestId) return;

        if (!(result instanceof Error)) {
            if (result.status.code == "10200") {
                result = result.data;
                this.setState({
                    totalReportData: result,
                    reportHeading
                })
            }
            else {
                this.setState({
                    totalReportData: 'error'
                })
                toastNotify(3, "Something went wrong");
            }
        }
        else {
            this.setState({
                totalReportData: 'error'
            })

            console.log("inside error");

            const response = JSON.parse(result.request.response);
            const code = response?.status?.code;

            console.log("code is", code);

            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }
                
            toastNotify(3, "Some error occured");
        }
    }
    
    onSubmit = async (e) => {
        e.preventDefault();

        const data = {
            platform: this.state.selectedPlatform,
        }

        this.validateData(data, e)
    }
    validateData = async (data, e) => {
        let result = await getStoryInsights(data.storyId, "story");
        if (!(result instanceof Error)) {
            if (result.status.code == "10200") {
                result = result.data[0];
                this.setState({
                    totalData: result
                })
            }
            else {
                this.setState({
                    totalData: 'error'
                })
                toastNotify(3, "Something went wrong");
            }
        }
        else {
            this.setState({
                totalData: 'error'
            })

            const response = JSON.parse(result.request.response);
            const code = response?.status?.code;

            console.log("code is", code);

            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }
            
            toastNotify(3, "Some error occured");
        }
    }
    render() {

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        let analysisCardContent;
        if (typeof this.storyId == 'undefined') {

            analysisCardContent = (
                <div>
                    <p className="spacing-metric"><b>Total Views :</b> {this.state.totalData.totalViewCount}</p>
                    <p className="spacing-metric"><b>Total Claps :</b> {this.state.totalData.totalClapCount}</p>
                    <p className="spacing-metric"><b>Unique Views :</b> {this.state.totalData.uniqueViewCount}</p>
                    <p className="spacing-metric"><b>Unique Claps :</b> {this.state.totalData.uniqueClapCount}</p>

                    <p className="spacing-metric"><b>Total iimjobs Views :</b> {this.state.totalData.iimjobsTotalViewCount}</p>
                    <p className="spacing-metric"><b>Total iimjobs Claps :</b> {this.state.totalData.iimjobsTotalClapCount}</p>

                    <p className="spacing-metric"><b>Total hirist Views :</b> {this.state.totalData.hiristTotalViewCount}</p>
                    <p className="spacing-metric"><b>Total hirist Claps :</b> {this.state.totalData.hiristTotalClapCount}</p>


                    <p className="spacing-metric"><b>Unique iimjobs Views :</b> {this.state.totalData.iimjobsUniqueViewCount}</p>
                    <p className="spacing-metric"><b>Unique iimjobs Claps :</b> {this.state.totalData.iimjobsUniqueClapCount}</p>
                    <p className="spacing-metric"><b>Unique hirist Views :</b> {this.state.totalData.hiristUniqueViewCount}</p>
                    <p className="spacing-metric"><b>Unique hirist Claps :</b> {this.state.totalData.hiristUniqueClapCount}</p>
                </div>
            )
        }
        else {
            analysisCardContent = (
                <div>
                    <p className="spacing-metric"><b>Total Views :</b> {this.state.totalData.totalViewCount}</p>
                    <p className="spacing-metric"><b>TotalClaps :</b> {this.state.totalData.totalClapCount}</p>
                    <p className="spacing-metric"><b>Unique Views :</b> {this.state.totalData.uniqueViewCount}</p>
                    <p className="spacing-metric"><b>Unique Claps :</b> {this.state.totalData.uniqueClapCount}</p>
                </div>
            )
        }
        let analysisCardReportContent;
        analysisCardReportContent = (
           <div className="report-card-content">
                <p className="heading-report"><b>Story Report</b></p>
                <table border="1" className="story-report">
                    <tbody>
                        <tr className="table_header">
                            <th className="table_header">Sn no.</th>
                            <th className="table_header">Portal</th>
                            <th className="table_header">Total Stories this month</th>
                            <th className="table_header">Total Brands this month</th>
                            <th className="table_header">Views</th>
                            <th className="table_header">Claps</th>
                        </tr>
                        <tr className="table_content">
                            <td className="table_content"><p>1</p></td>
                            <td className="table_content"><p>iimjobs</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.iimjobsStories}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.iimjobsBrands}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.iimjobsViews}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.iimjobsClaps}</p></td>
                        </tr>
                        <tr className="table_content">
                            <td className="table_content"><p>2</p></td>
                            <td className="table_content"><p>hirist</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.hiristStories}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.hiristBrands}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.hiristViews}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.hiristClaps}</p></td>
                        </tr>
                        <tr className="table_content">
                            <td className="table_content"><p></p></td>
                            <td className="table_content"><p><b>Total</b></p></td>
                            <td className="table_content"><p><b>{sumCounts(this.state.totalReportData.iimjobsStories, this.state.totalReportData.hiristStories)}</b></p></td>
                            <td className="table_content"><p><b>{sumCounts(this.state.totalReportData.iimjobsBrands, this.state.totalReportData.hiristBrands)}</b></p></td>
                            <td className="table_content"><p><b>{sumCounts(this.state.totalReportData.iimjobsViews, this.state.totalReportData.hiristViews)}</b></p></td>
                            <td className="table_content"><p><b>{sumCounts(this.state.totalReportData.iimjobsClaps, this.state.totalReportData.hiristClaps)}</b></p></td>
                        </tr>    
                    </tbody>
                </table>
           </div>    
        )

        let activeUniqueBrandsRows;
        if (this.state.totalReportData.uniqueBrands && this.state.totalReportData.uniqueBrands.length){
            activeUniqueBrandsRows = (
                this.state.totalReportData.uniqueBrands.map((item, index) => {
                    return (
                        <tr key={index} rowindex={index} className="table_content"  >
                            <td>
                                <p>{index}</p>
                            </td>
                            <td>
                                <p>{item.name}</p>
                            </td>
                            <td>
                                <p>{item.iimjobsStories && item.hiristStories ? item.iimjobsStories+item.hiristStories : item.iimjobsStories ? item.iimjobsStories : item.hiristStories ? item.hiristStories : 0}</p>
                            </td>
                            <td>
                                <p>{item.iimjobsStories ? item.iimjobsStories : 0}</p>
                            </td>
                            <td>
                                <p>{item.iimjobsTotalViewCount ? item.iimjobsTotalViewCount : 0}</p>
                            </td>
                            <td>
                                <p>{item.iimjobsTotalClapCount ? item.iimjobsTotalClapCount : 0}</p>
                            </td>
                            <td>
                                <p>{item.hiristStories ? item.hiristStories : 0}</p>
                            </td>
                            <td>
                                <p>{item.hiristTotalViewCount ? item.hiristTotalViewCount : 0}</p>
                            </td>
                            <td>
                                <p>{item.hiristTotalClapCount ? item.hiristTotalClapCount : 0}</p>
                            </td>
                        </tr>
                    )
                })
            )
        }
        let analysisCardUniqueBrandsContent;
        analysisCardUniqueBrandsContent = (
            <div>
                <table border="1" className="story-uniqueBrands-report">
                    <tbody>
                        <tr className="table-header">
                            <th className="table_header">Sn no.</th>
                            <th className="table_header">Unique Brands</th>
                            <th className="table_header">No. Of Stories</th>
                            <th className="table_header">iimjobs</th>
                            <th className="table_header">hirist</th>
                        </tr>
                        {activeUniqueBrandsRows}   
                    </tbody>
                </table>
            </div>
        )
        return (
            <div className="bodyWrapper">
                <Header />
                <section className="insights_header">
                    <h1>Story Insights</h1>
                    <div className={"main-wrapper" + (typeof this.storyId == 'undefined' ? ' report-only' : '')}>

                        {typeof this.storyId != 'undefined' && <div className="insights-wrapper">
                            <h3 className={"loader " + (this.state.totalData == "" ? '' : 'hidden')}><b>Loading...</b></h3>
                            <div className="wrapper">
                                <div className={"wrapperForm " + (this.state.totalData == "" || this.state.totalData == 'error' ? 'hidden' : '')}>
                                    {/* <div className="form-group">
                                        <label>Select Platform:</label>
                                        <select onChange={(e) => this.setCompanyID(e)}>
                                            <option key="0" value=" ">All</option>
                                            <option key="1" value="1">iimjobs</option>
                                            <option key="2" value="2">hirist</option>
                                        </select>
                                        <button type="submit" id="btnSubmit" className="btn-default" onClick={(e) => this.onSubmit(e)}>GO</button>
                                    </div> */}
                                    <div className="analysis-card" >
                                        {analysisCardContent}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        
                        <div className="insights-report">
                            <div className="date-box">
                                <div className="startDateContainer"> 
                                    <div className="date-label form-group-heading">Start Date*</div>
                                    <input className="date-input" type="date" value={this.state.startDate} max={this.state.endDate || undefined} onChange={this.setStartDate} />
                                </div>
                                <div className="endDateContainer">
                                    <div className="date-label form-group-heading">End Date*</div>
                                    <input className="date-input" type="date" value={this.state.endDate} min={this.state.startDate || undefined} onChange={this.setEndDate} />
                                </div>
                            </div>
                            <div className="submitButton">
                                <button className="buttonReport submit-report-btn" onClick={this.handleClick}>Submit</button>
                            </div>

                            <h3 className={"loader " + (this.state.clicked == true && this.state.totalReportData == '' ? '' : 'hidden')}><b>Loading...</b></h3>
                            {this.state.totalReportData != '' && this.state.totalReportData != 'error' && <h2 className="report-range-heading">{this.state.reportHeading}</h2>}
                            <div className="wrapper">
                                <div className={"wrapperForm " + (this.state.totalReportData == "" || this.state.totalReportData == 'error' ? 'hidden' : '')}>
                                    <div className="analysisReport-card" >
                                        {analysisCardReportContent}
                                    </div>
                                </div>
                                <div className={"wrapperForm " + (this.state.totalReportData == "" || this.state.totalReportData == 'error' ? 'hidden' : '')}>
                                    <div className="analysisReport-card unique-brands-report" >
                                        <div>
                                            <table border="1" className="story-uniqueBrands-report">
                                                <tbody>
                                                    <tr className="table-header">
                                                        <th className="table_header">Sn no.</th>
                                                        <th className="table_header">Unique Brands</th>
                                                        <th className="table_header">No. Of Stories</th>
                                                        <th className="table_header">iimjobs</th>
                                                        <th className="table_header">iimjobsTotalViewCount</th>
                                                        <th className="table_header">iimjobsTotalClapCount</th>
                                                        <th className="table_header">hirist</th>
                                                        <th className="table_header">hiristTotalViewCount</th>
                                                        <th className="table_header">hiristTotalClapCount</th>
                                                    </tr>
                                                    {activeUniqueBrandsRows}   
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        )
    }
}
export default withRouter(Insights);